<div class="select-wrapper" *transloco="let t">
  <span
    [ngClass]="hasShortText ? '' : 'min-w-24'"
    class="text-xs font-bold 2xl:text-sm"
    [class.text-[#bfbfbf]]="disabled"
  >
    {{ prefixLabel }}
  </span>
  <div [class]="containerClasses">
    @if (useNativeMobileSelect) {
      <select
        class="mb-native-select p-1"
        [ngModel]="value"
        (ngModelChange)="onValueChange($event)"
        [disabled]="disabled"
      >
        <option value="" [disabled]="true">
          {{ placeholder }}
        </option>
        @for (option of options; track option.value) {
          <option [value]="option.value">
            {{
              isFullyDisplayed
                ? option.label
                : hasTranslation
                  ? t(option.label)
                  : (option.label | truncate: 30)
            }}
          </option>
        }
      </select>
      <img
        [src]="ASSET_CONSTANTS.I_arrow_down"
        alt="Select"
        class="h-5 w-5 shrink-0 grayscale"
      />
    } @else {
      <nz-select
        [(ngModel)]="value"
        (ngModelChange)="onValueChange($event)"
        [nzPlaceHolder]="placeholder"
        [nzBorderless]="true"
        [nzShowSearch]="searchable"
        [nzOptionOverflowSize]="effectiveOptionOverflowSize"
        [nzDropdownStyle]="effectiveDropdownStyle"
        [nzBackdrop]="mobileBackdropEnabled"
        [disabled]="disabled"
        [nzSuffixIcon]="suffixIcon"
      >
        @for (option of options; track option.value) {
          <nz-option
            [nzValue]="option.value"
            [nzLabel]="
              isFullyDisplayed
                ? option.label
                : hasTranslation
                  ? t(option.label)
                  : (option.label | truncate: 30)
            "
          />
        }
        <ng-template #suffixIcon>
          <img
            [src]="ASSET_CONSTANTS.I_arrow_down"
            alt="Select"
            class="h-5 w-5 grayscale"
          />
        </ng-template>
      </nz-select>
    }
  </div>

  <!-- Error message displayed above the select -->
  <div *ngIf="hasError && errorMessage" class="error-message">
    {{ t(errorMessage) }}
  </div>
</div>
